/**
 * to display text if no search results are found
 *
 * @module views/components/NullSearchResult
 * @memberof -Common
 */
import './NullSearchResult.scss';

import React from 'react';

import PropTypes from 'prop-types';

import Grid from '@ulta/core/components/GridContainer/GridContainer';
import Text from '@ulta/core/components/Text/Text';

/**
 * Represents a nullSearchResult component
 *
 * @method
 * @param {NullSearchResultProps} props - React properties passed from composition
 * @returns NullSearchResult
 */
export const NullSearchResult = function( props ){
  return (
    <Grid>
      <div className='NullSearchResult'>
        <Text textStyle='title-6'
          textAlign='center'
        >{ props.headline }</Text>
        <Text textStyle='body-2'
          textAlign='center'
        >{ props.description }</Text>
      </div>
    </Grid>
  );
};

/**
 * Property type definitions
 *
 * @typedef NullSearchResultProps
 * @type {object}
 * @property {string} headline - display headline for search results
 * @property {string} description - display description for search results
 */
export const propTypes =  {
  headline: PropTypes.string,
  description: PropTypes.string
};

NullSearchResult.propTypes = propTypes;

export default NullSearchResult;
